import React from 'react';
import CheckIcon from 'assets/livenicons/ic_check.svg';

import styles from './styles.module.scss';

export const LifeWithLiven = () => {
  return (
    <div className={styles.checkoutAchieveBoxWrapper}>
      <div className={styles.checkoutAchieveBox}>
        <h6 className={styles.title}>What Loóna can help you with</h6>
        <div className={styles.checklist}>
          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>Continuous focus and concentration</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>Elevated energy levels</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>Improved sleep quality and schedule</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>Emotional stability</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>No guilt for getting relaxed</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>Efficient performance at work</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={CheckIcon} alt="" />
            <span>Stable self-care routine</span>
          </p>
        </div>
      </div>
    </div>
  );
};
